import React, { useState, useRef, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import ApiClient from "../../FindagramAdmin/BaseUrl/ApiClient";
import "./Login.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import loginbg from "../../assets/images/loginbg.png";
import findagramLogo from "../../assets/images/logoFindagram.png";
import * as Yup from "yup";
import { useFormik } from "formik";

const Login = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Please enter a valid email")
        .required("Please enter your email"),
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .required("Please enter your password"),
    }),
    onSubmit: async (values) => {
      setLoading(true);

      ApiClient.post("/auth/admin/login", values)
        .then((response) => {
          const { accessToken, refreshToken, user } =
            response.data.responseData.data;

          // console.log(response.data.responseData.data);

          localStorage.setItem("accessToken", accessToken);
          localStorage.setItem("refreshToken", refreshToken);
          localStorage.setItem("authUser", JSON.stringify(user));

          toast.success("Successfully logged in!");
          history.push("/business-list");
        })
        .catch((error) => {
          // console.log("Full Error:", error);
          // console.log(error.response?.data);

          (error?.response?.data?.responseMessage || ["Login failed"]).forEach(
            (msg) => {
              toast.error(msg);
            }
          );
        })
        .finally(() => {
          if (isMounted.current) {
            setLoading(false); // ✅ Safe from memory leak
          }
        });
    },
  });

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="auth-page-content custom-auth-page">
        <MetaTags>
          <title>Admin Login | Findagram</title>
        </MetaTags>

        <div className="header-navbar">
          <div className="logo-col">
            <Link to="/" className="logo-link">
              <img src={findagramLogo} alt="Findagram" height="60" />
            </Link>
          </div>
          <div className="button-col"></div>
        </div>
        <div className="header-line border-bottom"></div>
        <div
          className="background-section"
          style={{
            backgroundImage: `url(${loginbg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            minHeight: "calc(100vh - 100px)",
          }}
        >
          <Container className="form-container">
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5} className="card-col">
                <Card className="login-card mt-4">
                  <CardBody className="card-body">
                    <h5 className="welcome-text text-center text-dark">
                      Welcome Back!
                    </h5>
                    <p className="subtitle-text text-left">
                      Please enter your details to sign in.
                    </p>

                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                      className="login-form"
                    >
                      <div className="form-group mb-3 text-start">
                        <Label
                          htmlFor="email"
                          className="form-label formemail"
                        >
                          Email
                        </Label>
                        <Input
                          name="email"
                          className="form-control form-controlinput"
                          placeholder="Enter email here"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email}
                          invalid={
                            !!(
                              validation.touched.email &&
                              validation.errors.email
                            )
                          }
                        />
                        {validation.touched.email &&
                        validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="form-group mb-3 text-start">
                        <Label
                          htmlFor="password"
                          className="form-label formemail"
                        >
                          Password
                        </Label>
                        <Input
                          name="password"
                          value={validation.values.password}
                          type="password"
                          className="form-control form-controlinput"
                          placeholder="Enter password here"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            !!(
                              validation.touched.password &&
                              validation.errors.password
                            )
                          }
                        />
                        {validation.touched.password &&
                        validation.errors.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="remember-row">
                        <p className="forgot-col">
                          <Link
                            to="/forgot-password"
                            className="forgot-link text-center"
                          >
                            Forgot Password?
                          </Link>
                        </p>
                      </div>

                      <div className="form-group mb-3">
                        <Button
                          className="w-100 signin-btn"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Signing In...
                            </>
                          ) : (
                            "Sign In"
                          )}
                        </Button>
                      </div>

                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Login;
